import React from 'react'
import { ChakraProvider, extendTheme } from '@chakra-ui/react'

import { GlobalProvider } from 'providers/GlobalProvider'
import themeData from './Theme/themeData'
import App from './App'
import { AuthProvider } from './providers/AuthProvider'

const importAll = r => r.keys().forEach(r)
importAll(require.context('./htmlEmail', true, /\.png$/))

function Root() {
  const theme = extendTheme({ ...themeData })
  const globalState = {}
  return (
    <AuthProvider>
      <GlobalProvider initData={globalState}>
        <ChakraProvider theme={theme}>
          <App />
        </ChakraProvider>
      </GlobalProvider>
    </AuthProvider>
  )
}

export default Root
